module.exports = __webpack_public_path__ + "static/media/toyota-provider.95a977b4.svg";